// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__h3vQY","requiredAsterisk":"Info_requiredAsterisk__ItTyt"};